import { render, staticRenderFns } from "./currentTime.vue?vue&type=template&id=3e7082f8&scoped=true&"
import script from "./currentTime.vue?vue&type=script&lang=js&"
export * from "./currentTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7082f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e7082f8')) {
      api.createRecord('3e7082f8', component.options)
    } else {
      api.reload('3e7082f8', component.options)
    }
    module.hot.accept("./currentTime.vue?vue&type=template&id=3e7082f8&scoped=true&", function () {
      api.rerender('3e7082f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/components/currentTime.vue"
export default component.exports